// extracted by mini-css-extract-plugin
export default {"icon":"icon--NCyK7egXC7","action":"action--C6j6sNd6c8"};